"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var pick_1 = __importDefault(require("lodash/pick"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var queries_1 = require("utils/firebase/queries");
var hooks_1 = require("utils/hooks");
var ordered_1 = require("utils/selectors/ordered");
var ExtUrlsField_1 = __importDefault(require("./ExtUrlsField"));
var utils_1 = require("./utils");
var PricingInsightsForm = function (_a) {
    var _b;
    var service = _a.service;
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [(0, queries_1.insightRequestsForServiceQuery)(service.id)]; });
    var insightRequests = (0, react_redux_1.useSelector)((0, ordered_1.makeSelectInsightRequestsForService)(service.id));
    var initialValues = __assign(__assign({}, (0, pick_1.default)(service, ['pricingInsightsTeaserUrl'])), { pricingInsightsExtUrls: (_b = service.pricingInsightsExtUrls) !== null && _b !== void 0 ? _b : [{ productName: service.niceName || service.name }] });
    var _c = __read((0, hooks_1.useSubmitter)('services', service.id), 1), updateService = _c[0];
    if (!service) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mb: 2 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, mb: 4 }, { children: "Pricing Insights URLs" })), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ initialValues: initialValues, onSubmit: function (values) { return updateService(values); }, validate: utils_1.validateUnique }, { children: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting, dirty = _a.dirty;
                    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 2, alignItems: "center" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, mb: 2 }, { children: "Teaser Page" })), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "pricingInsightsTeaserUrl", color: "secondary", disabled: submitting, component: TextField_1.default, validate: utils_1.isValidNotionUrl, format: utils_1.makePublicNotionUrl, parse: utils_1.makePublicNotionUrl, label: "Teaser URL", fullWidth: true })] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, mb: 2 }, { children: "Pages with unrestricted invoices" })) })), (0, jsx_runtime_1.jsx)(ExtUrlsField_1.default, {})] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ my: 4 }, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, __assign({ type: "submit", disabled: submitting || !dirty, sx: { mr: 2 } }, { children: ["Save", !!(insightRequests === null || insightRequests === void 0 ? void 0 : insightRequests.length) && (!service.pricingInsightsTeaserUrl || !service.pricingInsightsExtUrls)
                                            && ' and notify pending insights'] })) }))] })));
                } }))] })));
};
exports.default = PricingInsightsForm;
